import React, { Component } from 'react';
import { connect } from 'react-redux';
import { hashHistory } from 'react-router';
import LocalizedStrings from 'react-localization';
import {
  userLoginRequest,
  otpVerifyRequest,
  otpResendRequest,
  mfaReset,
} from '../../actions.es6';
import { sesssionMonitor } from '../../../../lib/access.es6';
import { getEnvironmentInformation, reloadPage } from '../../../../lib/utils.es6';
import { updateGlobalLanguage } from '../../../Main/actions.es6';
import { localisedText } from '../../../../lib/localisation.es6';
import Hero from './components/Hero/Hero';

const getForgotPasswordURL = function() {
  const env = getEnvironmentInformation();
  const realm = env.credentials.realm;
  return `${env.servicesURLs.centralAuthentication}auth/realms/${realm}/login-actions/reset-credentials?client_id=${env.credentials.clientID}`;
};

export class OldMutualLandingPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      labels: new LocalizedStrings(localisedText),
    };
    this.login = this.login.bind(this);
    this.openForgotPassword = this.openForgotPassword.bind(this);
    this.updateGlobalLanguage = this.updateGlobalLanguage.bind(this);
  }

  login(credentials) {
    this.props.dispatch(userLoginRequest(credentials));
  }

  openForgotPassword() {
    window.location.href = getForgotPasswordURL();
  }

  updateGlobalLanguage(language) {
    this.props.dispatch(updateGlobalLanguage(language));
  }

  handleOtpVerify(pendingAuthToken, otp) {
    this.props.dispatch(otpVerifyRequest(pendingAuthToken, otp));
  }

  handleOtpResend(pendingAuthToken) {
    this.props.dispatch(otpResendRequest(pendingAuthToken));
  }

  handleOtpCancel() {
    this.props.dispatch(mfaReset());
  }

  updateLanguage() {
    const language = this.props.globalData.language;
    const resetLanguage = !language;
    const labels = this.state.labels;
    if (resetLanguage || labels.getLanguage() !== language) {
      labels.setLanguage(language);
      this.updateGlobalLanguage(language);
    }
  }

  componentWillMount() {
    localStorage.clear();
    this.updateLanguage();
  }

  componentDidUpdate() {
    if (
      this.props.loginData.AuthData &&
      this.props.loginData.AuthData.access_token &&
      this.props.loginData.sessionOpen
    ) {
      sesssionMonitor();
      hashHistory.push('admin/home');
      reloadPage();
    }
    this.updateLanguage();
  }

  render() {
    var loginData = this.props.loginData;

    return (
      <Hero
        login={this.login}
        loading={loginData.loader}
        loginError={loginData.errors}
        mfaPending={loginData.mfaPending}
        pendingAuthToken={loginData.mfaPendingAuthToken}
        maskedEmail={loginData.mfaMaskedEmail}
        mfaLoading={loginData.mfaLoading}
        mfaError={loginData.mfaError}
        mfaResent={loginData.mfaResent}
        onVerify={this.handleOtpVerify.bind(this)}
        onResend={this.handleOtpResend.bind(this)}
        onCancel={this.handleOtpCancel.bind(this)}
        forgetpassword={this.openForgotPassword}
        language={this.props.globalData.language}
        updateGlobalLanguage={this.updateGlobalLanguage}
        labels={this.state.labels}
      />
    );
  }
}

export default connect(function(state) {
  return {
    loginData: state.login,
    globalData: state.global,
  };
})(OldMutualLandingPage);
